import React from "react";
import Sticky from "react-stickynode";
import { PaddedWrapper } from "./paddedWrapper";
import { Flex } from "rebass/styled-components";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { noticeDisplayed } from "../../globalStorage/noticeBanner";
import { useIsDesktopApp } from "../../MVVM/Hooks/useIsDesktopApp";

const Page = styled(PaddedWrapper)`
  width: 100%;
  margin: auto;
  column-gap: ${(props) => props.theme.space[9]}px;

  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    column-gap: ${(props) => props.theme.space[7]}px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[2]}) {
    flex-direction: column;
  }

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    flex-direction: column;
    padding-left: 15px;
  }
`;

const MainRail = styled(Flex)`
  flex-basis: 900px;
  flex-grow: 1;
  flex-direction: column;
`;

const SideRailContent = styled(Flex)`
  flex-direction: column;
  width: 100%;

  ::-webkit-scrollbar {
    display: none;
  }

  > div:not(:last-child) {
    margin-bottom: ${(props) => props.theme.space[5]}px;
  }
`;

const SideRail = styled(Flex).attrs({
  pb: [7, 7, 10],
})`
  flex-basis: 400px;

  flex-direction: column;

  ${(props) => {
    return ` 
      @media (max-width: ${props.theme.breakpoints[2]}) {
        ${
          props.showOnMobile
            ? `min-height: auto;
          flex-basis: unset;
          
          ${SideRailContent} {
            height: auto;
            position: static;
          }
          `
            : "display: none;"
        }
      }
    `;
  }}
`;

function StickySideRail({
  enabled = true,
  showOnMobile = true,
  children,
  offset = false,
  view,
}) {
  const isDesktop = useIsDesktopApp();
  const bannerDisplayed = useRecoilValue(noticeDisplayed);

  let topOffset = bannerDisplayed ? 125 : 82; //82 is our original offset - height of the banner
  if (offset) topOffset = offset;

  if (isDesktop.isDesktop && view === "connectedAccounts") return <></>;
  return (
    <>
      {" "}
      <SideRail pb={[7, 7, 10]} showOnMobile={showOnMobile}>
        <Sticky
          top={topOffset}
          bottomBoundary={"#sitecontent"}
          enabled={enabled}
        >
          <SideRailContent>{children}</SideRailContent>
        </Sticky>
      </SideRail>
    </>
  );
}

export { Page, MainRail, StickySideRail };
